export default function loadCordova(cb: () => void) {
  document.addEventListener('deviceready', () => {
    cb()
  }, false)
}
